// extracted by mini-css-extract-plugin
export default {"title":"Cholesterol_title__w3-2R","readingsRow":"Cholesterol_readingsRow__76Yo5","toggleItem":"Cholesterol_toggleItem__buRHL","toggleRow":"Cholesterol_toggleRow__ZGy+l"};